import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProviderSchedules, StateStatus } from '@guryou/redux';
const useProviderSchedule = () => {
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.provider.schedule);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getProviderSchedules());
    }
  }, [dispatch, status]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useProviderSchedule;